import { render, staticRenderFns } from "./LgFinderPageGrupoContrato.vue?vue&type=template&id=4cd5c1ef"
import script from "./LgFinderPageGrupoContrato.vue?vue&type=script&lang=js"
export * from "./LgFinderPageGrupoContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports